import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ActivityResponse, NotificationMarkAsReadResponse } from '../models/activity';
import { Api } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class ActivityService extends Api {
  public list(page = 1): Observable<ActivityResponse> {
    const page_size = 24;
    return this.withIdToken().get<ActivityResponse>("/devices/notifications", {
        page,
        page_size,
    });
  }

  public markAsRead(notificationId: string) {
    return this.withIdToken().delete<NotificationMarkAsReadResponse>(`/devices/notifications/${notificationId}`);
  }

  public markAllAsSeen() {
    return this.withIdToken().put<NotificationMarkAsReadResponse>('/devices/notifications', {});
  }

  public markAllAsRead() {
    return this.withIdToken().delete<NotificationMarkAsReadResponse>('/devices/notifications');
  }
}
